/* Accessible native dialogs and shopping overlays; no catalog or price duplication. */
(() => {
  if (!customElements.get('opale-dialog')) customElements.define('opale-dialog', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-op-dialog-open]');
      this.opener?.addEventListener('click', () => this.dialog.showModal(), { signal });
      this.querySelector('[data-op-dialog-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog?.addEventListener('click', event => { if (event.target === this.dialog && (event.clientX < this.dialog.getBoundingClientRect().left || event.clientX > this.dialog.getBoundingClientRect().right || event.clientY < this.dialog.getBoundingClientRect().top || event.clientY > this.dialog.getBoundingClientRect().bottom)) this.dialog.close(); }, { signal });
      this.dialog?.addEventListener('close', () => this.opener?.focus(), { signal });
    }
    disconnectedCallback() { this.dialog?.close(); this.controller?.abort(); }
  });
  function setupHeader(root = document) {
    const header = root.querySelector('opale-header');
    if (!header || header.dataset.shoppingReady) return;
    header.dataset.shoppingReady = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    header.shoppingController = controller;
    header.querySelectorAll('.op-search, .op-mobile-menu').forEach(details => {
      const panel = details.querySelector('[data-op-panel]');
      details.addEventListener('toggle', () => {
        if (details.open) {
          document.body.classList.add('op-overlay-open');
          panel?.setAttribute('aria-modal', 'true');
          (details.querySelector('input') || panel?.querySelector('button,a'))?.focus();
        } else {
          panel?.removeAttribute('aria-modal');
          if (!header.querySelector('.op-search[open], .op-mobile-menu[open]')) document.body.classList.remove('op-overlay-open');
        }
      }, { signal });
      details.querySelector('[data-op-panel-close]')?.addEventListener('click', () => {
        details.open = false; details.querySelector('summary')?.focus();
      }, { signal });
      details.addEventListener('keydown', event => {
        if (event.key !== 'Tab' || !details.open) return;
        const items = Array.from(panel.querySelectorAll('summary,a,button,input,select')).filter(item => !item.disabled && item.getClientRects().length);
        const first = items[0], last = items.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, { signal });
    });
  }
  setupHeader();
  document.addEventListener('shopify:section:load', () => setupHeader());
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelector('opale-header')?.shoppingController?.abort();
    document.body.classList.remove('op-overlay-open');
  });
  // Native modal-opener/product-modal owns zoom focus, Escape and dismissal.
  // Add left/right navigation while keeping the product's original high-resolution images.
  document.addEventListener('keydown', event => {
    const modal = document.querySelector('product-modal[open]');
    if (!modal || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    const images = Array.from(modal.querySelectorAll('.product-media-modal__content > [data-media-id]'));
    if (!images.length) return;
    const current = Math.max(0, images.findIndex(image => image.classList.contains('active')));
    const next = images[(current + (event.key === 'ArrowRight' ? 1 : -1) + images.length) % images.length];
    event.preventDefault();
    images.forEach(image => image.classList.toggle('active', image === next));
    next.scrollIntoView({ block: 'nearest', behavior: 'auto' });
  });
})();
